import { render, staticRenderFns } from "./BetPerResultClashes.vue?vue&type=template&id=39075963&scoped=true&"
import script from "./BetPerResultClashes.vue?vue&type=script&lang=js&"
export * from "./BetPerResultClashes.vue?vue&type=script&lang=js&"
import style0 from "./BetPerResultClashes.vue?vue&type=style&index=0&id=39075963&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39075963",
  null
  
)

export default component.exports